import ReactGA from 'react-ga4';

ReactGA.initialize('G-T7EWM7958J');

export default ReactGA;
